import styled from "@emotion/styled";
import { GhostButton } from "src/components/Buttons";

export const DefaultContainer = styled.div<{
  state: "selected" | "disabled" | null;
  isHighlighted?: boolean;
}>`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
  height: 66px;
  justify-content: space-between;
  padding: 12px 16px;

  ${({ isHighlighted }) =>
    isHighlighted &&
    `
    background-color: rgba(255, 251, 235, 1);
    border: 2px solid rgba(227, 192, 57, 1);
    box-shadow: 0 0 0 4px rgba(227, 192, 57, 0.1);
    transform: scale(1.02);
  `}
`;

export const SelectedContainer = styled(DefaultContainer)`
  border: 2px solid rgba(64, 117, 255, 1);
  border-radius: 16px;
`;

export const DisabledContainer = styled(DefaultContainer)`
  background-color: rgba(249, 250, 251, 1);
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;
`;

export const PrimaryLenderChoiceButton = styled.button<{
  show: boolean;
  isSelected: boolean;
}>`
  all: unset;
  color: ${({ isSelected }) =>
    isSelected ? "rgba(227, 192, 57, 1)" : "rgba(174, 179, 187, 1)"};
  cursor: ${({ isSelected }) => (isSelected ? "default" : "pointer")};
  display: ${({ show }) => (show ? "block" : "none")};

  &:hover {
    color: rgba(227, 192, 57, 1);
  }
`;

export const LenderLogo = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(229, 235, 253, 1);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const LenderTitle = styled.div`
  font-size: 16px;
`;

export const RightContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-end;
`;

export const TimeStamp = styled.div`
  color: rgba(74, 84, 102, 1);
  font-size: 12px;
`;

export const Monogram = styled.div`
  background-color: rgba(229, 235, 253, 1);
  border-radius: 50%;
  color: rgba(20, 83, 245, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  height: 24px;
  text-transform: capitalize;
  width: 24px;
`;

export const EllipsesContainer = styled.div`
  position: relative;
`;

export const EllipsesMenuButton = styled(GhostButton)`
  padding: 8px;
  margin: 0px -9px;
`;

export const EllipsesDropdownMenu = styled.div<{ show: boolean }>`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(220, 223, 228, 1);
  border-radius: 12px;
  box-shadow:
    0px 2px 8px rgba(0, 0, 0, 0.06),
    0px 16px 64px -12px rgba(0, 0, 0, 0.1);
  display: ${({ show }) => (show ? "flex" : "none")};
  flex-direction: column;
  padding: 6px;
  position: absolute;
  top: 39px;
  right: -10px;
  width: 160px;
  z-index: 1;
  white-space: nowrap;
  box-sizing: content-box;
`;

export const EllipsesDropdownRow = styled(GhostButton)<{ loading?: boolean }>`
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: ${({ loading }) => (loading ? "center" : "flex-start")};
  width: 100%;
`;
